export const parseTime = (time: string): { hours: number; minutes: number } => {
  const parts = time.split(':').map(Number);
  return { hours: parts[0] ?? 0, minutes: parts[1] ?? 0 };
};

export const formatTime = (hours: number, minutes: number): string => {
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const normalizeTime = (time: string): string => {
  const { hours, minutes } = parseTime(time);
  return formatTime(hours, minutes);
};

export const timeToMinutes = (time: string): number => {
  const { hours, minutes } = parseTime(time);
  return hours * 60 + minutes;
};

export const addMinutes = (time: string, minutes: number): string => {
  const totalMinutes = timeToMinutes(time) + minutes;
  const newHours = Math.floor(totalMinutes / 60);
  const newMinutes = totalMinutes % 60;
  return formatTime(newHours, newMinutes);
};

export const formatTimeDisplay = (time: string | null | undefined): string => {
  if (!time) return '';
  return time.substring(0, 5);
};

export const generateTimeOptions = (
  intervalMinutes: number = 30,
  startHour: number = 0,
  endHour: number = 24
): { value: string; label: string }[] => {
  const startMinutes = startHour * 60;
  const endMinutes = endHour * 60;
  const totalSlots = (endMinutes - startMinutes) / intervalMinutes;

  return Array.from({ length: totalSlots }, (_, i) => {
    const totalMinutes = startMinutes + i * intervalMinutes;
    const time = formatTime(Math.floor(totalMinutes / 60), totalMinutes % 60);
    return { value: time, label: time };
  });
};

export const compareTime = (timeA: string | undefined, timeB: string | undefined): number => {
  return (timeA || '').localeCompare(timeB || '');
};

export const doTimesOverlap = (start1: string, end1: string, start2: string, end2: string): boolean => {
  const start1Minutes = timeToMinutes(start1);
  const end1Minutes = timeToMinutes(end1);
  const start2Minutes = timeToMinutes(start2);
  const end2Minutes = timeToMinutes(end2);
  return start1Minutes < end2Minutes && end1Minutes > start2Minutes;
};
